import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: true,
  error: false,
  user: null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    authStart: (state) => {
      state.loading = true;
      state.error = false;
    },
    authSuccess: (state, action) => {
      state.loading = false;
      state.error = false;
      state.user = action.payload;
    },
    authFailure: (state) => {
      state.loading = false;
      state.error = true;
    },
  },
});

const { actions, reducer } = authSlice;

export const { authStart, authSuccess, authFailure } = actions;

export default reducer;
